(function () {
  'use strict';

  var CONFIG = window.__gbConfig;
  if (!CONFIG) return;

  /**
   * Format a price in CENTS using the shop's Shopify money format.
   * Liquid's product.price is in cents (e.g. 2736000 for 27,360.00 TL).
   * This mirrors Liquid's {{ price | money }} output.
   *
   * @param {number} cents - Amount in cents (e.g. 2736000)
   * @returns {string}
   */
  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var moneyFormat = CONFIG.moneyFormat || '${{amount}}';
    var value = cents / 100;
    var sign = value < 0 ? '-' : '';
    var abs = Math.abs(value);
    var intPart = Math.floor(abs);
    var decStr = Math.round((abs - intPart) * 100).toString();
    while (decStr.length < 2) decStr = '0' + decStr;

    function addThousands(n, sep) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    var formatted = sign + addThousands(intPart, ',') + '.' + decStr;
    var withComma = sign + addThousands(intPart, '.') + ',' + decStr;
    var withApostrophe = sign + addThousands(intPart, "'") + '.' + decStr;
    var noDecimals = sign + addThousands(Math.round(abs), ',');
    var noDecimalsWithComma = sign + addThousands(Math.round(abs), '.');

    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withApostrophe)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, formatted);
  }

  function initTimer(badge) {
    var timerEl = badge.querySelector('.gb-timer');
    if (!timerEl) return;
    var endTimeAttr = timerEl.dataset.endTime;
    var endTime;
    if (/^\d+$/.test(endTimeAttr)) {
      endTime = parseInt(endTimeAttr, 10);
    } else {
      endTime = new Date(endTimeAttr).getTime();
    }
    var valueEl = timerEl.querySelector('.gb-timer-value');
    if (!endTime || !valueEl) return;

    function updateTimer() {
      var now = Date.now();
      var diff = endTime - now;
      if (diff <= 0) { valueEl.textContent = CONFIG.strings.expired; return; }
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var s = CONFIG.strings;
      if (days > 0) { valueEl.textContent = days + s.d + ' ' + hours + s.h + ' ' + minutes + s.m; }
      else if (hours > 0) { valueEl.textContent = hours + s.h + ' ' + minutes + s.m; }
      else { valueEl.textContent = minutes + s.m; }
    }
    updateTimer();
    setInterval(updateTimer, 60000);
  }

  function restartTimer(badge, newEndMs) {
    var timerEl = badge.querySelector('.gb-timer');
    if (!timerEl) return;
    timerEl.dataset.endTime = String(newEndMs);
    initTimer(badge);
  }

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  function confirmBadge(badge) { badge.classList.remove('gb-loading'); }

  function isDesignMode(badge) {
    return DESIGN_MODE || badge.dataset.designMode === 'true';
  }

  var DEMO_DISCOUNT = 30;
  var DEMO_PARTICIPANTS = 3;
  var DEMO_DURATION_MS = 2 * 24 * 60 * 60 * 1000;
  var DEMO_FOOTER_TEXT = 'Demo preview \u2014 sample campaign';

  /**
   * Sample campaign used to fill the badge in the theme editor when the
   * product has no live campaign, so the merchant sees a populated preview
   * instead of an empty shell.
   */
  function demoInfo(badge) {
    return {
      has_campaign: true,
      discount_percentage: DEMO_DISCOUNT,
      current_participants: DEMO_PARTICIPANTS,
      max_participants: parseInt(badge.dataset.maxParticipants || '10', 10),
      end_date: new Date(Date.now() + DEMO_DURATION_MS).toISOString(),
      is_demo: true
    };
  }

  /**
   * No campaign for this product. On the storefront the badge is removed.
   * In the theme editor it stays visible, filled with demo data.
   */
  function resolveNoCampaign(badge) {
    if (isDesignMode(badge)) { updateBadgeWithData(badge, demoInfo(badge)); return; }
    hideBadge(badge);
  }

  function hideBadge(badge) {
    badge.style.transition = 'opacity 0.3s ease';
    badge.style.opacity = '0';
    setTimeout(function () { badge.style.display = 'none'; }, 300);
  }

  /**
   * Overwrite badge with market-aware API data.
   *
   * PRICE STRATEGY: The API returns base-currency prices (from Gadget DB),
   * but the storefront shows market-localized prices (Shopify Markets converts).
   * So we NEVER use API prices directly. Instead:
   *   - Original price: from SSR data-original-price (Liquid's product.price = market cents)
   *   - Discount %: from API (market-correct campaign)
   *   - Group price: computed locally as originalCents * (1 - discount/100)
   *   - Savings: originalCents - groupCents
   *
   * This ensures prices match the product card's market-localized currency.
   */
  function updateBadgeWithData(badge, info) {
    if (info.has_campaign === false || info.max_groups_reached === true) {
      resolveNoCampaign(badge);
      return;
    }

    // SSR original price in market-correct cents (from Liquid's product.price)
    var ssrOriginalCents = parseInt(badge.dataset.originalPrice, 10) || 0;

    // Discount % from API (correct campaign for viewer's market)
    var pct = info.discount_percentage || 0;

    // --- Compute market-correct prices using SSR original × API discount ---
    if (ssrOriginalCents > 0 && pct > 0) {
      var groupCents = Math.round(ssrOriginalCents * (1 - pct / 100));
      var savingsCents = ssrOriginalCents - groupCents;

      var origEl = badge.querySelector('.gb-original-price');
      if (origEl) origEl.textContent = formatMoney(ssrOriginalCents);

      var grpEl = badge.querySelector('.gb-group-price');
      if (grpEl) grpEl.textContent = formatMoney(groupCents);

      var savingsEl = badge.querySelector('.gb-text-savings');
      if (savingsEl && CONFIG.strings.save) {
        if (savingsCents > 0) {
          savingsEl.textContent = CONFIG.strings.save.replace('{amount}', formatMoney(savingsCents));
          savingsEl.style.display = '';
        } else {
          savingsEl.style.display = 'none';
        }
      }
    }

    // --- Discount badge ---
    var discountEl = badge.querySelector('.gb-discount-badge');
    if (discountEl) {
      if (pct && pct > 0 && CONFIG.strings.discount_off) {
        discountEl.textContent = CONFIG.strings.discount_off.replace('{percent}', Math.round(pct));
        discountEl.style.display = '';
      } else {
        discountEl.style.display = 'none';
      }
    }

    // --- Timer: update to market-correct campaign end date ---
    if (info.end_date) {
      var endMs = new Date(info.end_date).getTime();
      if (endMs && !isNaN(endMs)) restartTimer(badge, endMs);
    }

    // --- Progress / participants ---
    var current = info.current_participants || 0;
    var max = info.max_participants || parseInt(badge.dataset.maxParticipants || '10', 10);
    badge.dataset.maxParticipants = max;
    var progressPct = Math.min((current / max) * 100, 100);

    var bar = badge.querySelector('.gb-progress-fill');
    if (bar) bar.style.width = Math.max(progressPct, 2) + '%';

    var spotsEl = badge.querySelector('.gb-spots-text');
    if (spotsEl) {
      spotsEl.textContent = CONFIG.strings.participantsCount
        .replace('{current}', current).replace('{max}', max);
      if ((max - current) <= 3) spotsEl.classList.add('gb-text-urgent');
      else spotsEl.classList.remove('gb-text-urgent');
    }

    // --- Footer text ---
    var footerText = info.is_demo
      ? (CONFIG.strings.demo_footer_text || DEMO_FOOTER_TEXT)
      : CONFIG.strings.footer_text;

    if (footerText) {
      var footerEls = badge.querySelectorAll('.gb-footer-text');
      footerEls.forEach(function (el) {
        if (!el.classList.contains('gb-timer-value')) {
          el.textContent = footerText;
        }
      });
    }

    badge.classList.toggle('gb-demo', info.is_demo === true);

    confirmBadge(badge);
  }

  function initBadges() {
    var badges = document.querySelectorAll('.gb-modern-card:not(.gb-placeholder)');
    if (!badges.length) return;

    var productIds = [];
    var badgeMap = {};

    badges.forEach(function (badge) {
      initTimer(badge);
      var productId = badge.dataset.productId;
      if (productId) {
        productIds.push(productId);
        if (!badgeMap[productId]) badgeMap[productId] = [];
        badgeMap[productId].push(badge);
      } else {
        confirmBadge(badge);
      }
    });

    if (!productIds.length) return;

    var apiResolved = false;
    var fallbackTimer = setTimeout(function () {
      if (!apiResolved) {
        badges.forEach(function (b) {
          if (!b.classList.contains('gb-loading')) return;
          resolveNoCampaign(b);
        });
      }
    }, 3000);

    var uniqueIds = productIds.filter(function (id, i, arr) { return arr.indexOf(id) === i; });
    var marketQS = '';
    if (CONFIG.marketId) marketQS += '&market_id=' + String(CONFIG.marketId).replace(/^gid:\/\/shopify\/Market\//, '');
    if (CONFIG.countryCode) marketQS += '&country=' + CONFIG.countryCode.toUpperCase();

    fetch(CONFIG.apiEndpoint + '/collection-products-status?product_ids=' + uniqueIds.join(',') + '&shop=' + CONFIG.shopDomain + marketQS)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        apiResolved = true;
        clearTimeout(fallbackTimer);
        if (data && data.success) {
          Object.keys(badgeMap).forEach(function (productId) {
            var info = data.products[productId];
            badgeMap[productId].forEach(function (badge) {
              if (info) updateBadgeWithData(badge, info);
              else resolveNoCampaign(badge);
            });
          });
        } else {
          badges.forEach(resolveNoCampaign);
        }
      })
      .catch(function (err) {
        apiResolved = true;
        clearTimeout(fallbackTimer);
        badges.forEach(resolveNoCampaign);
        console.warn('GroupBuy Dynamic Data Error:', err);
      });
  }

  window.gbInitBadges = initBadges;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadges);
  } else {
    initBadges();
  }
})();